import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const formatPrice = (price) =>
  new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price);

export default function PackageCard({ pkg }) {
  const { t, ml } = useLang();
  const features = ml(pkg.features);
  const featureList = Array.isArray(features) ? features : [];
  const popular = pkg.popular === true || pkg.popular === 1;

  return (
    <div
      data-testid={`package-card-${pkg.speed}`}
      className={`relative flex flex-col rounded-2xl border p-8 transition-all duration-300 hover:-translate-y-1 ${
        popular
          ? "border-transparent bg-gradient-to-br from-[#101436] via-[#1e1b4b] to-[#312e81] text-white shadow-xl"
          : "border-zinc-200 bg-white text-[#101436] shadow-sm hover:shadow-lg"
      }`}
    >
      {popular && (
        <span className="absolute -top-3.5 start-1/2 -translate-x-1/2 rounded-full bg-[#ff9800] px-4 py-1 text-xs font-bold uppercase tracking-[0.15em] text-[#1d1d1f]">
          {t("packages.popular")}
        </span>
      )}

      <p className={`text-sm font-bold uppercase tracking-[0.2em] ${popular ? "text-[#ff9800]" : "text-gray-400"}`}>
        {pkg.name}
      </p>

      <div className="mt-4 flex items-baseline gap-2">
        <span className="font-display text-6xl font-extrabold tracking-tighter">{pkg.speed}</span>
        <span className={`text-lg font-bold ${popular ? "text-[#ff9800]" : "text-[#4F46E5]"}`}>{t("packages.mbps")}</span>
      </div>

      <div className="mt-5 flex items-baseline gap-1">
        <span className="font-display text-3xl font-bold tracking-tight">₺{formatPrice(pkg.price)}</span>
        <span className={popular ? "text-zinc-400" : "text-gray-400"}>{t("packages.perMonth")}</span>
      </div>

      <ul className="mt-7 flex-1 space-y-3">
        {featureList.map((feature, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm">
            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
              popular ? "bg-[#ff9800] text-[#1d1d1f]" : "bg-[#f3f0ff] text-[#4F46E5]"
            }`}>
              <Check className="h-3 w-3" strokeWidth={3} />
            </span>
            <span className={popular ? "text-zinc-300" : "text-gray-600"}>{feature}</span>
          </li>
        ))}
      </ul>

      <Link
        to={`/tarifeler/${pkg.speed}`}
        data-testid={`package-detail-${pkg.speed}`}
        className={`mt-8 flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-bold transition-all ${
          popular
            ? "bg-[#ff9800] text-[#1d1d1f] hover:bg-[#f57c00]"
            : "border-2 border-[#4F46E5] text-[#4F46E5] hover:bg-[#4F46E5] hover:text-white"
        }`}
      >
        {t("packages.select")}
        <ArrowRight className="h-4 w-4 rtl:rotate-180" />
      </Link>
    </div>
  );
}
